import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./OrderHistory.css";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import CheckOut from "../Orders/CheckOut";
import useOrderLogic from "../Orders/UserOrderFunction";
import { getImagePath } from "../../../SharedFiles/Helper/utils";
import QuantityModal from "../Orders/quantityModel";
import PlaceButton from "../Orders/PlaceQutotaionButton";
import toast, { Toaster } from "react-hot-toast";
import { HashLoader } from "react-spinners";
import {
  showDeleteConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import {
  CancelSQAndSO,
  convertQuotationToOrder,
  GetAttachments,
} from "../../../APIServices/SalesService/OrderService/OrderThunk";
import { decryptUserInfo } from "../../../SharedFiles/decryption/Decryption";
import ImageView from "../../../SharedFiles/ImageViewer/imageView";

const SOHistory = () => {
  const {
    cartItems,
    setCartItems,
    customerForm,
    setCustomerForm,
    showModal,
    openModal,
    closeModal,
    selectedItem,
    setSelectedItem,
    quantity,
    quantityNos,
    setQuantityNos,
    setQuantity,
    type,
    setType,
    handleQtyChange,
    editing,
    isCheckout,
    handleConfirmOrder,
    handlePlaceOrder,
    setIsCheckout,
    showAddress,
    setshowAddress,
    customernameView,
    setCustomernameView,
    customerData,
    setCustomerData,
    showItemData,
    setShowItemData,
    setEditing,
    InProgress,
    setInProgress,
    addToCart,
    remarks,
    setRemarks,
    removeFromCart,
  } = useOrderLogic();
  const userData = sessionStorage.getItem("user");
  // const pageData = localStorage.getItem('PAGEData');
  const parsedUserData = userData ? JSON.parse(userData) : null;
  const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
  const docEntry = sessionStorage.getItem("DocEntry");
  const historyData = sessionStorage.getItem("HistoryDetails");
  const [praseData, setPraseData] = useState(JSON.parse(historyData));
  const [imageData, setImageData] = useState([]);
  const navigate = useNavigate();
  // const [dataInfo, setDataInfo] = useState([]);
  // const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const selectedType = localStorage.getItem("PAGEData");
  const {
    UpdateSalesQ,
    QuotationAttachment,
    UpdateSalesOrder,
    QuotationToOrderResponse,
    CancelSQAndSOResponse,
    error,
    loading,
  } = useSelector((state) => state.order);
  const isLoading = () => {
    return (
      loading.UpdateSalesQ ||
      loading.UpdateSalesOrder ||
      loading.QuotationToOrderResponse ||
      loading.QuotationAttachment ||
      loading.CancelSQAndSOResponse
    );
  };
  const handleSuccess = (message, key) => {
    toast.success(message);
    navigate("/Sales/OrderHistory");
    setInProgress((prev) => ({ ...prev, [key]: false }));
    cleanupAndRedirect();
  };
  const Checker = () => {
    if (
      InProgress.deleteSQandSO &&
      CancelSQAndSOResponse === "Cancelled successfully"
    ) {
      handleSuccess(
        selectedType === "SO"
          ? "Order cancel successful"
          : "Quotation cancel successful",
        "deleteSQandSO"
      );
      return;
    }
    if (InProgress.fetchQuoteImage && error?.QuotationAttachmentError) {
      toast.error(error.QuotationAttachmentError.errorMessage);
      setInProgress((prev) => ({ ...prev, fetchQuoteImage: false }));
      return;
    }
    if (InProgress.fetchQuoteImage && QuotationAttachment) {
      setImageData(QuotationAttachment);
      setInProgress((prev) => ({ ...prev, fetchQuoteImage: false }));
    }
    if (QuotationToOrderResponse === "Success" && InProgress.ConvertOrder) {
      handleSuccess("Quotation Successful Approved", "ConvertOrder");
      return;
    }
    if (!editing) return;

    if (InProgress.UpdateSaleSQ && error?.UpdateSaleSQError) {
      const updateError = error.UpdateSaleSQError;
      if (updateError.errors && typeof updateError.errors === "object") {
        Object.entries(updateError.errors).forEach(([field, messages]) => {
          messages.forEach((msg) => {
            toast.error(`${field}: ${msg}`);
          });
        });
      } else if (updateError.errorMessage) {
        toast.error(updateError.errorMessage);
      }
      setInProgress((prev) => ({ ...prev, UpdateSaleSQ: false }));
      return;
    }
    if (error?.QuotationToOrderError && InProgress.ConvertOrder) {
      toast.error(error.QuotationToOrderError.errorMessage);
      setInProgress((prev) => ({ ...prev, ConvertOrder: false }));
      return;
    }

    if (InProgress.UpdateSaleSQ && UpdateSalesQ === "Success") {
      if (selectedType === "SO") {
        handleSuccess("Order Update Successful", "UpdateSaleSQ");
      } else {
        handleSuccess("Quotation Update Successful", "UpdateSaleSQ");
      }
      return;
    }
    if (InProgress.UpdateSO && UpdateSalesOrder === "Success") {
      handleSuccess("Order Update Successful", "UpdateSO");
      return;
    }
  };

  const cleanupAndRedirect = () => {
    sessionStorage.removeItem("DocEntry");
    sessionStorage.removeItem("cartItems");
    sessionStorage.removeItem("itemGroup");
    sessionStorage.removeItem("itemGroupFlag");
    setIsCheckout(false);
    setType("");
    setCustomerForm({
      customerName: "",
      address: "",
      contactNumber: "",
      remarks: "",
      customerCode: "",
      addressShort: "",
    });
    setCustomerData("");
    setCartItems([]);
  };
  useEffect(() => {
    Checker();
  }, [
    UpdateSalesQ,
    UpdateSalesOrder,
    QuotationAttachment,
    error,
    selectedType,
    CancelSQAndSOResponse,
    QuotationToOrderResponse,
    InProgress,
  ]);
  const handleNavItemPage = (item) => {
    setEditing(true);
    localStorage.setItem("Edit", true);
    sessionStorage.removeItem("cartItems");
    const itemsToEdit = praseData.map((entry) => ({
      item_Code: entry.item_Code,
      item_Name: entry.item_Description,
      poNum: entry.customerpo,
      lineNum: entry.lineNum,
      quantity: entry.bundle,
      height: entry.height,
      noinbundle: entry.noinbundle,
      deliverY_TYPE: entry.deliverY_TYPE,
      Customer_Code: entry.customer_Code,
      address: entry.address,
      shortAddress: entry.delivery_Address,
      remarks: entry.remarks,
      contactNumber: entry.contact_Number,
      barWeight: entry.barWeight,
      quantityNos: entry.bundle * entry.noinbundle,
      type: "bundle",
      priority: entry.priority === "N" ? false : true,
    }));
    setCustomerForm({
      customerName: `${praseData[0].customer_Code} - ${praseData[0].customer_Name}`,
      address: praseData[0].address,
      contactNumber: praseData[0].contactNumber || "",
      remarks: praseData[0].remarks || "",
      poNum: praseData[0].customerpo,
      customerCode: praseData[0].customer_Code,
      addressShort: praseData[0].shortAddress,
    });
    sessionStorage.setItem("cartItems", JSON.stringify(itemsToEdit));
    setCartItems(itemsToEdit);
  };
  const handleType = (selectvalue) => {
    setQuantity("");
    setQuantityNos("");
    setType(selectvalue);
  };
  const handleBackClick = () => {
    sessionStorage.removeItem("cartItems");
    sessionStorage.removeItem("HistoryDetails");
    setImageData([]);
    navigate("/sales/OrderHistory");
  };
  const handQuotationToOrder = () => {
    showSubmitConfirmation(() => {
      // const docEntry = sessionStorage.getItem("DocEntry");
      setInProgress((prev) => ({ ...prev, ConvertOrder: true }));
      dispatch(convertQuotationToOrder({ docEntry }));
    });
  };
  const handlegetImage = () => {
    const DocType = selectedType === "SO" ? "Order" : "Quotation";
    setInProgress((prev) => ({ ...prev, fetchQuoteImage: true }));
    dispatch(GetAttachments({ docEntry, DocType: DocType }));
  };

  const handleCancel = () => {
    showDeleteConfirmation(() => {
      const DocType = selectedType === "SO" ? "Order" : "Quotation";
      setInProgress((prev) => ({ ...prev, deleteSQandSO: true }));
      dispatch(CancelSQAndSO({ docEntry, DocType: DocType }));
    });
  };
  return (
    <>
      {editing ? (
        <>
          <CheckOut
            customerForm={customerForm}
            setCustomerForm={setCustomerForm}
            editing={editing}
            setEditing={setEditing}
            cartItems={cartItems}
            setCartItems={setCartItems}
            removeFromCart={removeFromCart}
            openModal={openModal}
            selectedItem={selectedItem}
            setCustomerData={setCustomerData}
            customerData={customerData}
            setSelectedItem={setSelectedItem}
            closeModal={closeModal}
            quantity={quantity}
            quantityNos={quantityNos}
            type={type}
            showItemData={showItemData}
            setShowItemData={setShowItemData}
            setType={setType}
            setQuantity={setQuantity}
            setQuantityNos={setQuantityNos}
            handleQtyChange={handleQtyChange}
            addToCart={addToCart}
            isCheckout={isCheckout}
            setIsCheckout={setIsCheckout}
            showAddress={showAddress}
            setshowAddress={setshowAddress}
            remarks={remarks}
            InProgress={InProgress}
            setInProgress={setInProgress}
            setRemarks={setRemarks}
            customernameView={customernameView}
            setCustomernameView={setCustomernameView}
          />

          {showModal && selectedItem && (
            <QuantityModal
              showModal={showModal}
              handleQtyChange={handleQtyChange}
              closeModal={closeModal}
              handleType={handleType}
              type={type}
              selectedItem={selectedItem}
              quantityNos={quantityNos}
              quantity={quantity}
              addToCart={addToCart}
              setCartItems={setCartItems}
              cartItems={cartItems}
            />
          )}
          <PlaceButton
            handlePlaceOrder={handlePlaceOrder}
            isCheckout={isCheckout}
            cartItems={cartItems}
            handleConfirmOrder={handleConfirmOrder}
            editing={editing}
            selectedType={selectedType}
          />
        </>
      ) : (
        <>
          <div className="checkback">
            <button className="SalesBackButton" onClick={handleBackClick}>
              <IoMdArrowRoundBack className="backicon" />
              <p className="item">Back</p>
            </button>
            <h6 className="item">
              {selectedType === "SQ" ? "SALES QUOTATION" : "SALES ORDER"}
            </h6>
          </div>

          {/* <div className="History-main-div animate-fade-in">
            <div className="order-info">
              <h2>Document No: {praseData[0]?.order_No}</h2>
              <div className="details-row">
                <div className="labels">
                  <div>Document Date</div>
                  <div>Due Date</div>
                  <div>Address</div>
                </div>
                <div className="values">
                  <div>{praseData[0]?.doc_Date}</div>
                  <div>{praseData[0]?.due_Date}</div>
                  <div>{praseData[0]?.address}</div>
                </div>
              </div>
            </div>

            <div className="order-items">
              <div className="items-header">
                <div>
                  <h3>Items ({praseData.length})</h3>
                </div>
                <div className="ApproveDiv">
                  {praseData[0].status === "O" &&
                    (selectedType === "SQ" ||
                      (selectedType === "SO" &&
                        (decryptedUserInfo[0].USERID == 5 ||
                          decryptedUserInfo[0].USERID == 6))) && (
                      <button className="AddCart" onClick={handleNavItemPage}>
                        EDIT
                      </button>
                    )}

                  {(decryptedUserInfo[0].USERID == 5 ||
                    decryptedUserInfo[0].USERID == 6) &&
                    selectedType === "SQ" &&
                    praseData[0].status === "O" && (
                      <>
                        <button
                          className="buttonApprove"
                          onClick={handQuotationToOrder}
                        >
                          APPROVE
                        </button>
                      </>
                    )}
                  {praseData[0].status === "O" &&
                    (selectedType === "SQ" ||
                      (selectedType === "SO" &&
                        (decryptedUserInfo[0].USERID == 5 ||
                          decryptedUserInfo[0].USERID == 6))) && (
                      <button className="buttonApprove" onClick={handleCancel}>
                        CANCEL
                      </button>
                    )}
                </div>
              </div>

              {praseData.map((item, index) => (
                <div className="item-card" key={index}>
                  <div className="item-card-content">
                    <div className="item-left">
                      <p>{item.item_Code}</p>
                      <p className="itemname">{item.item_Description}</p>
                      <p>
                        UOM: {item.uom} &nbsp; Quantity: {item.qty} &nbsp; PendingQty:{item?.qty-item?.delivery_Qty}
                      </p>
                    </div>
                    <div className="item-right">
                      <p>Line Total</p>
                      <p>
                        Rs.
                        {item.line_Total?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                      <p className="itemname">Rs.{item.item_Price} (Per Qty)</p>
                    </div>
                  </div>
                  <div className="item-details-row">
                    <p>In Stock {item.in_Stock}</p>
                    <p>Ordered {item.ordered}</p>
                    <p>Committed {item.commited}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="order-notes">
              <h3>Notes</h3>
              <div className="details-row">
                <div className="labels">
                  <div>Sales Employee</div>
                  <div>Journal</div>
                  <div>Remarks</div>
                </div>
                <div className="values">
                  <div>{praseData[0].sales_Employee}</div>
                  <div>{praseData[0].journal}</div>
                  <div>{praseData[0].remarks}</div>
                </div>
              </div>
            </div>

            <div className="order-total">
              <h3>Total</h3>
              <div className="details-row">
                <div className="labels">
                  <div>Total Tax Amount</div>
                  <div>Total Amount</div>
                </div>
                <div className="values">
                  <div>
                    Rs.
                    {praseData.length > 0
                      ? praseData[0].total_Tax_Amount?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </div>
                  <div className="price-font">
                    Rs.
                    {praseData.length > 0
                      ? praseData[0].doc_Total?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </div>
                </div>
              </div>
            </div>
            <div className="preview-button-wrapper">
              <button className="preview-button" onClick={handlegetImage}>
                Preview
              </button>
            </div>
            <ImageView imageData={imageData} />
          </div> */}
          <div className="History-main-div animate-fade-in">
            {!praseData ||
            !Array.isArray(praseData) ||
            praseData.length === 0 ? (
              <div
                style={{ padding: "20px", textAlign: "center", color: "#777" }}
              >
                <p className="no-orders-message">No document data found</p>
              </div>
            ) : (
              <>
                <div className="order-info">
                  <h2>Document No: {praseData?.[0]?.order_No}</h2>
                  <div className="details-row">
                    <div className="labels">
                      <div>Document Date</div>
                      <div>Due Date</div>
                      <div>Address</div>
                    </div>
                    <div className="values">
                      <div>{praseData?.[0]?.doc_Date}</div>
                      <div>{praseData?.[0]?.due_Date}</div>
                      <div>{praseData?.[0]?.address}</div>
                    </div>
                  </div>
                </div>

                <div className="order-items">
                  <div className="items-header">
                    <div>
                      <h3>Items ({praseData?.length || 0})</h3>
                    </div>

                    <div className="ApproveDiv">
                      {praseData?.[0]?.status === "O" &&
                        (selectedType === "SQ" ||
                          (selectedType === "SO" &&
                            (decryptedUserInfo[0].USERID == 6 ||
                              decryptedUserInfo[0].USERID == 7))) && (
                          <button
                            className="AddCart"
                            onClick={handleNavItemPage}
                          >
                            EDIT
                          </button>
                        )}

                      {(decryptedUserInfo[0].USERID == 6 ||
                        decryptedUserInfo[0].USERID == 7) &&
                        selectedType === "SQ" &&
                        praseData?.[0]?.status === "O" && (
                          <button
                            className="buttonApprove"
                            onClick={handQuotationToOrder}
                          >
                            APPROVE
                          </button>
                        )}

                      {(decryptedUserInfo?.[0]?.USERID == 6 ||
                        decryptedUserInfo?.[0]?.USERID == 7) &&
                        (selectedType === "SQ" || selectedType === "SO") &&
                        praseData?.[0]?.status === "O" && (
                          <button
                            className="buttonApprove"
                            onClick={handleCancel}
                          >
                            CANCEL
                          </button>
                        )}
                    </div>
                  </div>
                  {praseData?.map((item, index) => (
                    <div
                      className="item-card"
                      key={item?.line_Id || `${item?.item_Code}-${index}`}
                    >
                      <div className="item-card-content">
                        <div className="item-left">
                          <p>{item?.item_Code}</p>
                          <p className="itemname">{item?.item_Description}</p>
                          <p>
                            UOM: {item?.uom} &nbsp; Quantity: {item?.qty} &nbsp;
                            PendingQty: {item?.qty - item?.delivery_Qty}
                          </p>
                        </div>
                        <div className="item-right">
                          <p>Line Total</p>
                          <p>
                            Rs.
                            {item?.line_Total?.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p className="itemname">
                            Rs.{item?.item_Price} (Per Qty)
                          </p>
                        </div>
                      </div>
                      <div className="item-details-row">
                        <p>In Stock {item?.in_Stock}</p>
                        <p>Ordered {item?.ordered}</p>
                        <p>Committed {item?.commited}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="order-notes">
                  <h3>Notes</h3>
                  <div className="details-row">
                    <div className="labels">
                      <div>Sales Employee</div>
                      <div>Journal</div>
                      <div>Remarks</div>
                      <div>Vehicle No</div>
                    </div>
                    <div className="values">
                      <div>{praseData?.[0]?.sales_Employee}</div>
                      <div>{praseData?.[0]?.journal}</div>
                      <div>{praseData?.[0]?.remarks || "-"}</div>
                      <div>{praseData?.[0]?.vehicle_Number || "-"}</div>
                    </div>
                  </div>
                </div>
                <div className="order-total">
                  <h3>Total</h3>
                  <div className="details-row">
                    <div className="labels">
                      <div>Total Tax Amount</div>
                      <div>Total Amount</div>
                    </div>
                    <div className="values">
                      <div>
                        Rs.
                        {praseData?.[0]?.total_Tax_Amount?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) || "0.00"}
                      </div>
                      <div className="price-font">
                        Rs.
                        {praseData?.[0]?.doc_Total?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || "0.00"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="preview-button-wrapper">
                  <button className="preview-button" onClick={handlegetImage}>
                    Preview
                  </button>
                </div>
                <ImageView imageData={imageData} />
              </>
            )}
          </div>
        </>
      )}
      {isLoading() && (
        <div className="loader-sales">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </>
  );
};

export default SOHistory;
